module.exports = __webpack_public_path__ + "static/media/appointments.4e1e55ae.svg";